import React from 'react';
import ReactGA from 'react-ga4';

import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { FormattedMessage, WrappedComponentProps, injectIntl } from 'react-intl';
import { Checkbox, Form, Spin } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { CheckboxChangeEventTarget } from 'antd/lib/checkbox/Checkbox';
import { v4 } from 'uuid';
import { debounce, get, isEmpty } from 'lodash';

import {
  getCondoBookPackageWithCard,
  ICondoReviewBookState,
  ICouponState,
  setCondoBookingComplete,
  setCondoGuest,
  setCondoPriceChangedError,
  setErrorMessageExpirationDate,
  setErrorMessageCardNumber,
  setErrorMessageZipCode,
  IReviewBookState,
  IInsuranceState,
  InsuranceSelection,
  insuranceActions,
  refreshInsuranceQuote,
} from '@store/slices';
import {
  buildCertificateContextWithPersistedFallback,
  GetWalletNumber,
  mergeCondoCertificateRouteHint,
  RootState,
  computeIsStripePaymentMethodsEnabled,
  getSelectedCurrency,
  isInsuranceBookingSelectionMissing,
  isEnableCreditLine,
  roundMoney2,
  dollarsToStripeCents,
  isCertificateApplied,
  isDisplayCertificates,
  GetEffectiveClientCashPercentage,
} from '@share/utils';
import {
  ICertificatesState,
  ICondoFiltersState,
  IMenuState,
  getNavigationMenu,
  setLoginRedirect,
} from '@share/store/slices';
import {
  GetPreferenceValue,
  MERCHANT_CHARGE_DESCRIPTION_FIELD_KEY,
  getAvailabilityId,
  getCondoId,
  getMemberPhone,
  removingDashFromString,
  updateCondoGuest,
  getCountryIsoCode,
  getState,
} from '@utils';
import { getSessionObj, renderNumber, getFullUrl, isValidEmail, UrlUtils, LoginType, getCurrencyText } from '@share/utils';
import { BlueButton, Loading } from '@share/components';
import {
  CONDO_SESSION_KEY,
  CONDO_UNITS_SESSION_KEY_LABEL,
  C_C_COMPLETE_BOOKING,
  C_PP,
  C_TERMS,
  Routes,
  QUOTE_LABEL,
  SESSION_KEY_TOKEN_NAME_PARAM,
  LIFE_STYLE_NAME_PARAM
} from '@share/constants';
import { ICondoGuestBooking, ICondoBookPackageWithCard, IFormErrors, ScrollBehaviorEnum, ICondoBookingSummary } from '@common-types';
import { countriesCode } from '@share/constants';
import { NON_REFUNDABLE_TYPE, USA_STATES } from '@constants';
import { BookingErrorsEnum, IAccount, INavigation, ItemTypeEnum } from '@share/common-types';
import { ISessionKey } from '@share/common-types';
import { CondoGuestInfo } from '../condo-guest-info';
import { WhiteButton } from '../../../../common/white-button';
import { CondoPaymentMethod } from '../condo-payment-method';
import { CondoConfirmationEmail } from '../condo-confirmation-email';
import { CondoCancellationPolicies } from '../condo-cancellation-policies';
import { BookingConfirmed } from '../../notification';
import { CondoBookingFailedWarning } from '../../condo-booking-failed-warning';
import { CondoBookingPendingNotification } from '../booking-pending-notification';
import { CondoUnitNotAvailableNotification } from '../condo-unit-not-available';
import { ILoginState, ICondosStaticState } from '@share/store/slices';
import { CondoAvailabilityStatusModal, ModalMessage, ModalConfirmation, ThreeDSModal, Insurance, InsuranceRequiredMessage } from '@components';

import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './style.scss';
import { StripeBtnTypes, stripePromise } from '../../../../../../share/utils/stripe';
import ExpressCheckoutButtons from '../../../../../../share/components/express-checkout-buttons/component';
import ForceFullStripeCheckout from '../../../../../../share/components/express-checkout-buttons/force-full-section/component';
import StripeCheckoutButtons from '../../../../../../share/components/express-checkout-buttons/stripe-checkout-buttons/component';
import { Elements } from '@stripe/react-stripe-js';
import { IMultiplePayments } from '../../../../review-book/review-book/review-book';
import GlobalLoading from '../../../../../../share/components/global-spinner/component';

interface IMapStateToProps {
  reviewBookStore: IReviewBookState;
  condoReviewBookStore: ICondoReviewBookState;
  redeemCodeStore: ICouponState;
  condoFiltersStore: ICondoFiltersState;
  menuStore: IMenuState;
  loginStore: ILoginState;
  insuranceStore: IInsuranceState;
  condosStaticStore: ICondosStaticState;
  certificatesStore: ICertificatesState;
}

interface IMapDispatchToProps {
  getCondoBookPackageWithCard: (bookWithCard: ICondoBookPackageWithCard, onErrorCallback: (errorCode: string) => void) => void;
  setCondoGuest: (guest: ICondoGuestBooking) => void;
  setCondoPriceChangedError: (priceChanged: boolean) => void;
  setCondoBookingComplete: (bookingComplete: boolean) => void;
  setErrorMessageExpirationDate: (value: boolean) => void;
  setErrorMessageCardNumber: (value: boolean) => void;
  setErrorMessageZipCode: (value: boolean) => void;
  getNavigationMenu: () => void;
  setLoginRedirect: (redirect: string) => void;
  setInsuranceSelection: (selection: InsuranceSelection | null) => void;
  refreshInsuranceQuote: (state: string, priceChangeHandler?: () => void) => void;
  resetInsurance: () => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, RouteComponentProps, WrappedComponentProps { }

interface IState {
  isAccept: boolean;
  isAcceptKnowBeforeYouGo: boolean;
  isAcceptNoChangesAllowed: boolean;
  isAcceptCancellationPolicy: boolean;
  isAcceptIsInsurance: boolean;
  isSomeoneElse: boolean;
  isClientCash: boolean;
  isClientCashNotRefundable: boolean;
  isReward: boolean;
  showNotRefundableMessage: boolean;
  showNotRefundableConfirmModal: boolean;
  isButtonCompleteHidden: boolean;
  multiplePayments: IMultiplePayments;
  paymentSelected: string;
  scrollToPaymentSelect: boolean;
  expressWalletProbeComplete: boolean;
  hasExpressWalletMethods: boolean;
  forceFullStripeCheckoutPhase: 'details' | 'payment';
  pendingPaymentSwitch: string | null;
  /** Force-full insurance flow: true while the guest still has to complete the insurance step (country/state/accept-decline). */
  forceFullInsuranceStepBlocked: boolean;
  /** Force-full insurance flow: flag empty residency selectors in red once the guest clicks "View Fields". */
  showInsuranceResidencyErrors: boolean;
  /** Force-full insurance flow: residency selection, owned here so it survives the details↔payment phase switch. */
  insuranceResidencyCountry: string;
  insuranceResidencyState: string;
}

const ZERO = 0;
const SECOND_ELEMENT = 2;
const TEN_SEC = 10000;
const PRIVACY = 'privacy1';

/** Keeps Express element in real layout so Stripe can detect Apple/Google Pay (clip/sr-only breaks probe). */
const STRIPE_EXPRESS_PROBE_SR_ONLY: React.CSSProperties = {
  position: 'fixed',
  left: 0,
  top: 0,
  width: 'min(100vw, 480px)',
  height: 52,
  opacity: 0,
  pointerEvents: 'none',
  zIndex: -1,
  overflow: 'hidden',
};

/** Card/billing fields registered on the same Form as guest info; omit when payment UI is hidden (force-full Stripe details step). */
const CONDO_PAYMENT_ROOT_KEYS = new Set<string>([
  'saveCard',
  'holderName',
  'cardNumber',
  'months',
  'years',
  'code',
  'addressLine1',
  'addressLine2',
  'city',
  'country',
  'state',
  'postalCode',
]);

class CondoReviewBookComponent extends React.Component<IProps, IState> {
  state: IState = {
    isAccept: false,
    isAcceptKnowBeforeYouGo: false,
    isAcceptNoChangesAllowed: false,
    isAcceptCancellationPolicy: false,
    isAcceptIsInsurance: false,
    isSomeoneElse: false,
    isClientCash: false,
    isClientCashNotRefundable: false,
    isReward: false,
    showNotRefundableMessage: false,
    showNotRefundableConfirmModal: false,
    isButtonCompleteHidden: false,
    multiplePayments: {
      amazonPay: false,
      applePay: false,
      googlePay: false,
      link: false,
      paypal: false
    },
    paymentSelected: '',
    scrollToPaymentSelect: false,
    expressWalletProbeComplete: false,
    hasExpressWalletMethods: false,
    forceFullStripeCheckoutPhase: 'details',
    pendingPaymentSwitch: null,
    forceFullInsuranceStepBlocked: true,
    showInsuranceResidencyErrors: false,
    insuranceResidencyCountry: '',
    insuranceResidencyState: '',
  };
  formRef = React.createRef<FormInstance>();
  wrapperRef = React.createRef<HTMLDivElement>();
  TWO: number = 2;
  insuranceContainerRef = React.createRef<HTMLDivElement>();

  onExpressWalletAvailabilityResolved = (hasWallets: boolean) => {
    this.setState({
      expressWalletProbeComplete: true,
      hasExpressWalletMethods: hasWallets,
    });
  };

  onChangeAccept = (e: { target: CheckboxChangeEventTarget }): void => {
    this.setState({ isAccept: e.target.checked });
  };

  onChangeAcceptKnowBeforeYouGo = (e: { target: CheckboxChangeEventTarget }): void => {
    this.setState({ isAcceptKnowBeforeYouGo: e.target.checked });
  };

  onChangeAcceptNoChangesAllowed = (e: { target: CheckboxChangeEventTarget }): void => {
    this.setState({ isAcceptNoChangesAllowed: e.target.checked });
  };

  onChangeAcceptCancellationPolicy = (e: { target: CheckboxChangeEventTarget }): void => {
    this.setState({ isAcceptCancellationPolicy: e.target.checked });
  };

  onChangeAcceptClientCash = (e: { target: CheckboxChangeEventTarget }): void => {
    this.setState({ isClientCash: e.target.checked });
  };

  onChangeAcceptIsInsurance = (e: { target: CheckboxChangeEventTarget }): void => {
    this.setState({ isAcceptIsInsurance: e.target.checked });
  };

  onChangeAcceptClientCashNotRefundable = (e: { target: CheckboxChangeEventTarget }): void => {
    this.setState({
      isClientCashNotRefundable: e.target.checked,
      showNotRefundableMessage: e.target.checked,
    });
  };

  onChangeAcceptReward = (e: { target: CheckboxChangeEventTarget }): void => {
    this.setState({ isReward: e.target.checked });
  };

  /** Force-full Stripe: return to the details page, keeping every prior selection. The acknowledgment
   *  checkboxes are controlled (`checked` bound to state) and the insurance selection is restored from
   *  the quote in the store, so nothing has to be re-entered. */
  handleForceFullBackToDetails = () => {
    // Drop any stale validation errors left on the (disabled) billing fields by a prior submit so
    // they don't reappear on return, and recompute validity so the guest-step "Next" button
    // reflects the already-valid guest fields instead of a stale flag from the payment step.
    this.formRef.current?.setFields([
      { name: 'country', errors: [] },
      { name: 'state', errors: [] },
      { name: 'postalCode', errors: [] },
    ]);
    this.setState({ forceFullStripeCheckoutPhase: 'details' });
    this.checkFormValidity();
  };

  /** Enter the force-full payment step. The payment fields were excluded from validity while on the
   *  details step, so `isButtonCompleteHidden` is stale-true; clear it immediately and re-run
   *  validation so the button starts disabled with the red message. Also re-sync the billing fields
   *  from the store and clear stale errors, so returning to this step keeps everything as it was
   *  (the locked country/state stay filled-not-red and the entered postal code is preserved). */
  handleForceFullGoToPayment = () => {
    const { card } = this.props.condoReviewBookStore;
    this.formRef.current?.setFields([
      { name: 'country', errors: [] },
      { name: 'state', errors: [] },
      { name: 'postalCode', value: card?.zipCode ?? '', errors: [] },
    ]);
    this.setState({ forceFullStripeCheckoutPhase: 'payment', isButtonCompleteHidden: false });
    this.checkFormValidity();
  };

  handleOnCompleteBooking = () => {
    const { condoReviewBookStore, loginStore } = this.props;
    const { account, userWallet } = loginStore;
    const { condoBookingSummary, bookingComplete, booking, selectedCondoReviewClientCash } =
      condoReviewBookStore;
    const { refundability } = condoBookingSummary ?? {};

    const selectedCondoReviewClientCashFinal = selectedCondoReviewClientCash ? selectedCondoReviewClientCash : 0;

    const hasClientCash = account?.hasClientCash;
    const walletIsExternal = account?.walletIsExternal;
    const walletSkipNonRefundable = account?.walletSkipNonRefundable;

    const isLogged = !!userWallet;

    const usedClientCash = bookingComplete && booking ? get(booking, 'clientCash', 0) : 0;

    const refundabilityFinal = (!walletSkipNonRefundable && !walletIsExternal && hasClientCash && isLogged && (selectedCondoReviewClientCashFinal > 0 || usedClientCash > 0)) ? NON_REFUNDABLE_TYPE : refundability;

    if (NON_REFUNDABLE_TYPE === refundabilityFinal) {
      this.setState({ showNotRefundableConfirmModal: true });
    } else {
      this.onCompleteBooking();
    }
  };

  onCompleteBooking = () => {
    const { guest } = this.props.condoReviewBookStore;

    this.formRef.current?.setFieldsValue({ email: guest?.email ?? '' });
    this.formRef.current?.setFieldsValue({ givenName: guest?.givenName ?? '' });
    this.formRef.current?.setFieldsValue({ surname: guest?.surname ?? '' });
    this.formRef.current?.setFieldsValue({ phone: guest?.phone ?? '' });

    Promise.all([this.formRef.current?.validateFields()])
      .then(() => {
        this.completeBooking();
      })
      .catch((error: IFormErrors) => {
        const { errorFields } = error;
        const { name } = errorFields[ZERO];
        const { scrollToField } = (this.formRef.current as any);

        (() => {
          scrollToField(name[ZERO], { behavior: ScrollBehaviorEnum.Smooth });
        })();
      });
  };

  completeBooking = () => {
    const { condoBookingSummary, card, guest, selectedCondoReviewClientCash } =
      this.props.condoReviewBookStore;
    const { account, userWallet, userWalletData } = this.props.loginStore;
    const { coupon } = this.props.redeemCodeStore;
    const { payNowPrice } = condoBookingSummary?.bookingCard?.bookingPrice ?? {};

    const certificateHint = mergeCondoCertificateRouteHint(
      this.props.history.location.state,
      this.props.condoFiltersStore,
    );
    const certificateApplied = isCertificateApplied(
      account as IAccount,
      certificateHint?.certificateId || this.props.condoFiltersStore.certificateId,
    );

    const convertionRate = userWalletData?.convertionRate ? userWalletData?.convertionRate : 1;
    const finalBalanceIntermediate = certificateApplied
      ? (payNowPrice ?? 0)
      : (payNowPrice ?? 0) - (selectedCondoReviewClientCash ? selectedCondoReviewClientCash * convertionRate : 0);
    const finalBalance = roundMoney2(finalBalanceIntermediate);

    const values = UrlUtils.getValues();
    const sessionKey = getSessionObj(
      values[CONDO_UNITS_SESSION_KEY_LABEL] as ISessionKey,
      values[CONDO_SESSION_KEY] as ISessionKey,
    );
    let quote;
    if (values[QUOTE_LABEL]) {
      quote = values[QUOTE_LABEL] as string;
    }

    const skipPayment = isEnableCreditLine(account);
    const creditCard = { ...card };

    const data: any = {
      sessionKey,
      bookingPrice: condoBookingSummary?.bookingCard?.bookingPrice?.payNowPrice ?? 0,
      condoId: getCondoId(),
      availabilityId: getAvailabilityId(),
      guests: [{ ...guest, phone: removingDashFromString(guest?.phone ?? '') }],
      supplierType: condoBookingSummary?.supplierType ?? '',
      quote,
    };

    if (!certificateApplied) {
      data.couponCode = coupon;
    }

    const displayCertificates = isDisplayCertificates(this.props.loginStore.account as IAccount);
    if (displayCertificates) {
      const certificateContext = buildCertificateContextWithPersistedFallback({
        certificateId: certificateHint?.certificateId,
        certificateItemId: certificateHint?.certificateItemId,
        certificates: this.props.certificatesStore?.data,
        itemType: ItemTypeEnum.Condo,
      });
      if (certificateContext) {
        data.certificateContext = certificateContext;
      }
    }

    const isPrivateWithToken = account?.type === LoginType.PrivateWithToken;
    const privateTokenFromUrl = account?.privateTokenFromUrl;
    if (isPrivateWithToken && privateTokenFromUrl) {
      const ssoSessionKey = UrlUtils.getSearchParam(SESSION_KEY_TOKEN_NAME_PARAM);
      data.ssoSessionKey = ssoSessionKey;
      data.lifeType = UrlUtils.getSearchParam(LIFE_STYLE_NAME_PARAM);
    }

    const hasClientCash = account?.hasClientCash;
    const isLogged = !!userWallet;

    if (!skipPayment) {
      const paymentMethod = { paymentMethodId: card?.id, CVC: card?.cvv };

    if (!certificateApplied && hasClientCash && isLogged) {
      data.clientCashAmount = selectedCondoReviewClientCash ? selectedCondoReviewClientCash : 0;

        if (finalBalance > 0) {
          if (!isEmpty(card?.id)) {
            data.paymentMethod = paymentMethod;
          } else {
            data.card = creditCard;
          }
        }
      } else {
        if (!isEmpty(card?.id)) {
          data.paymentMethod = paymentMethod;
        } else {
          data.card = creditCard;
        }
      }

      this.props.setErrorMessageExpirationDate(true);
      this.props.setErrorMessageCardNumber(true);
      this.props.setErrorMessageZipCode(true);
    } else if (hasClientCash && isLogged) {
      data.clientCashAmount = selectedCondoReviewClientCash ? selectedCondoReviewClientCash : 0;
    }
    this.props.getCondoBookPackageWithCard(data, () => {
      this.scrollToError();
    });

    ReactGA.event({
      category: account?.name as string,
      action: `${C_C_COMPLETE_BOOKING}_${account?.name.toUpperCase()}`,
      label: `User clicked complete booking on book`,
      nonInteraction: false,
    });
  };

  scrollToError = () => {
    this.wrapperRef.current?.scrollIntoView({ behavior: ScrollBehaviorEnum.Smooth });
  };

  onChangeSomeoneElse = (e: { target: CheckboxChangeEventTarget }) => {
    const { memberType } = (this.props.menuStore.items as INavigation);
    const { guest, condoBookingSummary } = this.props.condoReviewBookStore;
    const { givenName, surname } = condoBookingSummary?.mainGuest ?? {};

    if (!e.target.checked) {
      this.formRef.current?.setFieldsValue({ givenName: givenName });
      this.formRef.current?.setFieldsValue({ surname: surname });
      this.formRef.current?.setFieldsValue({
        phone: getMemberPhone(memberType, condoBookingSummary?.mainGuest?.phone),
      });
      this.formRef.current?.setFieldsValue({
        additionalEmail: guest?.additionalEmail,
      });
    } else if(e.target.checked) {
      this.formRef.current?.setFieldsValue({ givenName: undefined });
      this.formRef.current?.setFieldsValue({ surname: undefined });
      this.formRef.current?.setFieldsValue({
        phone: undefined,
      });
      if(!isEmpty(guest?.additionalEmail)) {
        this.formRef.current?.setFieldsValue({ additionalEmail: guest?.additionalEmail });
      }
    }

    this.setState({ isSomeoneElse: e.target.checked });
    this.props.setCondoGuest({
      ...(updateCondoGuest(guest, {
        isBookingForSomeoneElse: e.target.checked,
        givenName: !e.target.checked ? givenName : '',
        surname: !e.target.checked ? surname : '',
        phone: !e.target.checked
          ? getMemberPhone(memberType, condoBookingSummary?.mainGuest?.phone)
          : '',
      }) as ICondoGuestBooking),
      isBookingForSomeoneElse: e.target.checked,
    });

    this.checkFormValidity();

  };

  componentDidMount() {
    const { items } = this.props.menuStore;
    const { givenName, surname, email, phone, namePrefix } =
    this.props.condoReviewBookStore.condoBookingSummary?.mainGuest ?? {};

    // Force-full Stripe: the insurance answer lives in a store that outlives this page, so a choice
    // made on an earlier checkout would come back pre-selected here. Every checkout starts unanswered.
    if (this.props.loginStore.account?.forceStripeFull) {
      this.props.setInsuranceSelection(null);
    }

    const getCondoBookingGuest = localStorage.getItem('CONDO_BOOKING_GUEST_INFO_LABEL');
    
    let condoBookingGuest:any = {};
    if(getCondoBookingGuest && !isEmpty(getCondoBookingGuest)) {
      condoBookingGuest = JSON.parse(getCondoBookingGuest);
    }

    this.props.setCondoGuest({
      id: v4(),
      givenName: givenName ? givenName : '',
      namePrefix: namePrefix ? namePrefix : '',
      surname: surname ? surname : '',
      countryCode: '',
      phoneCountryCode: countriesCode[ZERO].dialCode,
      phone:
        items && getMemberPhone(items.memberType, phone)
          ? getMemberPhone(items.memberType, phone)
          : '',
      email: email ? email : '',
      additionalEmail: condoBookingGuest?.additionalEmail ? condoBookingGuest?.additionalEmail : '',
      isBookingForSomeoneElse: false,
      addressLine1: '',
      addressLine2: '',
      city: '',
      country: '',
      stateCode: '',
      zipCode: '',
    });

    if(this.state.isSomeoneElse !== condoBookingGuest?.isBookingForSomeoneElse) {
      this.setState({isSomeoneElse: condoBookingGuest?.isBookingForSomeoneElse})
    }
      
    this.checkFormValidity();

    this.props.setCondoBookingComplete(false);
  }

  getBookingErrorWarning = (certificateApplied: boolean): React.ReactNode | null => {
    const { bookingErrorCode, errorStripe } = this.props.condoReviewBookStore;

    let header = 'something.went.wrong';
    let description = bookingErrorCode as string;

    if (bookingErrorCode === BookingErrorsEnum.PaymentFailed) {
      header = 'payment.authorize.failed';
      description = 'check.card.details.or.use.another.payment.method';
    } else if (bookingErrorCode === BookingErrorsEnum.GuestInformationFailed) {
      header = 'issue.with.guest.information';
      description = 'check.you.entered.valid.guest.information';
    } else if (
      bookingErrorCode === BookingErrorsEnum.RoomsUnavailable ||
      bookingErrorCode === BookingErrorsEnum.SoldOut
    ) {
      return <CondoAvailabilityStatusModal certificateApplied={certificateApplied} />;
    } else if (bookingErrorCode === BookingErrorsEnum.General) {
      header = 'something.went.wrong';
      description = 'error.code.general';
    } else if (bookingErrorCode === BookingErrorsEnum.UnexpectedResponse) {
      header = 'something.went.wrong';
      description = 'there.may.be.an.issue';
    } else if (!isEmpty(errorStripe)) {
      header = 'something.went.wrong';
      description = errorStripe;
    }
    return <CondoBookingFailedWarning header={header} description={description} />;
  };

  componentDidUpdate(prevProps: Readonly<IProps>, prevState: IState) {
    const { account } = this.props.loginStore;
    const stripeRegionOk = computeIsStripePaymentMethodsEnabled(
      account,
      this.props.menuStore?.items?.siteId,
      this.props.menuStore?.items?.organizationId,
    );
    const suppressStripePaymentUI = stripeRegionOk && !!account?.forceStripeFull;
    if (!suppressStripePaymentUI && this.state.forceFullStripeCheckoutPhase !== 'details') {
      this.setState({ forceFullStripeCheckoutPhase: 'details' });
    }

    const { bookingComplete, errorBooking } = this.props.condoReviewBookStore;

    if (
      !prevProps.condoReviewBookStore?.bookingErrorCode ||
      prevProps.condoReviewBookStore?.bookingErrorCode !==
      this.props.condoReviewBookStore?.bookingErrorCode
    ) {
      if (this.props.condoReviewBookStore.bookingErrorCode === BookingErrorsEnum.PaymentFailed) {
        this.formRef.current?.setFields([
          { name: 'holderName', errors: [''] },
          { name: 'cardNumber', errors: [''] },
          { name: 'months', errors: [''] },
          { name: 'years', errors: [''] },
          { name: 'code', errors: [''] },
        ]);
      } else if (
        this.props.condoReviewBookStore.bookingErrorCode ===
        BookingErrorsEnum.GuestInformationFailed
      ) {
        this.formRef.current?.setFields([
          { name: 'prefixName', errors: [''] },
          { name: 'givenName', errors: [''] },
          { name: 'surname', errors: [''] },
          { name: 'phone', errors: [''] },
        ]);
      }
    }

    if (
      (bookingComplete && bookingComplete !== prevProps.condoReviewBookStore.bookingComplete) ||
      (errorBooking && errorBooking !== prevProps.condoReviewBookStore.errorBooking)
    ) {
      setTimeout(() => {
        this.props.getNavigationMenu();
      }, TEN_SEC);
    }

    if (prevState.paymentSelected !== this.state.paymentSelected) {
      this.checkFormValidity();
    }

    // Condos full-Stripe: mirror the insurance residency (and drive its quote) from the primary
    // address the guest fills in above, so the disabled insurance dropdowns always match it.
    this.syncForceFullResidencyFromGuest();
  }

  searchCondo = () => {
    UrlUtils.removeFromUrl(CONDO_UNITS_SESSION_KEY_LABEL);
    UrlUtils.removeFromUrl(CONDO_SESSION_KEY);

    this.props.history.push(
      `/${this.props.loginStore.account?.name}${Routes.CondoSearch}${location.search}`,
    );
  };

  bookAnotherUnit = () => {
    const condoId = Number(this.props.history.location.pathname.split('/')[SECOND_ELEMENT]);

    this.props.history.push(
      `/${this.props.loginStore.account?.name}${Routes.Condo}/${condoId}${location.search}`,
    );
  };

  hangleGoToLogin = () => {
    const { loginStore, history } = this.props;
    const { account } = loginStore;

    const { pathname, search } = history.location;
    this.props.setLoginRedirect(`${pathname}${isEmpty(search) ? '' : search}`);

    this.props.history.push(`/${account?.name}${Routes.Login}`);
  }

  hangleGoToSignUp = () => {
    const { loginStore, history } = this.props;
    const { account } = loginStore;

    const { pathname, search } = history.location;
    this.props.setLoginRedirect(`${pathname}${isEmpty(search) ? '' : search}`);

    this.props.history.push(`/${account?.name}${Routes.SignUp}`);
  }

  handleUpdateAddress = () => {
    const { condoReviewBookStore } = this.props;
    const { guest } = condoReviewBookStore;

    this.formRef.current?.setFieldsValue({ addressLine1: guest?.addressLine1 ?? '' });
    this.formRef.current?.setFieldsValue({ addressLine2: guest?.addressLine2 ?? '' });
    this.formRef.current?.setFieldsValue({ city: guest?.city ?? '' });
    this.formRef.current?.setFieldsValue({ country: guest?.country ?? '' });
    this.formRef.current?.setFieldsValue({ state: guest?.stateCode ?? '' });
    this.formRef.current?.setFieldsValue({ postalCode: guest?.zipCode ?? '' });
  };

  /** Force-full Stripe accounts divert to the legacy card form only when the guest opts into
   *  insurance. Mirrors the `forceFullLegacyCard` flag computed in render so `checkFormValidity`
   *  (a class method without render scope) can tell when the billing region is locked. */
  isForceFullLegacyCardActive = (): boolean => {
    const { loginStore, menuStore, insuranceStore, condoReviewBookStore } = this.props;
    const { account } = loginStore;
    const { card } = condoReviewBookStore;
    const { selection, insurance, error: insuranceError } = insuranceStore;

    const stripeRegionOk =
      !isEnableCreditLine(account) &&
      computeIsStripePaymentMethodsEnabled(
        account,
        menuStore?.items?.siteId,
        menuStore?.items?.organizationId,
      );
    const suppressStripePaymentUI = stripeRegionOk && !!account?.forceStripeFull;
    const forceFullInsuranceEnabled =
      suppressStripePaymentUI &&
      !!account?.enableInsurance &&
      !menuStore?.items?.isRemoveInsurance &&
      !card?.id;

    return (
      forceFullInsuranceEnabled &&
      !!insurance &&
      isEmpty(insuranceError) &&
      selection === InsuranceSelection.YES
    );
  };

  /** True while the condo full-Stripe insurance step is on screen (details phase). In this mode the
   *  insurance residency is mirrored from the primary-address section rather than picked separately. */
  isForceFullDetailsInsuranceActive = (): boolean => {
    const { loginStore, menuStore, condoReviewBookStore } = this.props;
    const { account } = loginStore;
    const { card } = condoReviewBookStore;

    const stripeRegionOk =
      !isEnableCreditLine(account) &&
      computeIsStripePaymentMethodsEnabled(
        account,
        menuStore?.items?.siteId,
        menuStore?.items?.organizationId,
      );
    const suppressStripePaymentUI = stripeRegionOk && !!account?.forceStripeFull;
    const forceFullInsuranceEnabled =
      suppressStripePaymentUI &&
      !!account?.enableInsurance &&
      !menuStore?.items?.isRemoveInsurance &&
      !card?.id;

    return forceFullInsuranceEnabled && this.state.forceFullStripeCheckoutPhase === 'details';
  };

  /** Map the primary-address (guest) country/state to the ISO country + USA_STATES postal code the
   *  insurance quote expects. Country name → ISO via the backend country list; RCI/Interval state code
   *  → postal code by matching the state name (falling back to the raw code). */
  deriveResidencyFromGuest = (): { country: string; state: string } => {
    const { condoReviewBookStore, condosStaticStore } = this.props;
    const { guest, condoBookingSummary } = condoReviewBookStore;
    const { condosCountriesCode } = condosStaticStore;
    const supplierType = condoBookingSummary?.supplierType;

    const country = getCountryIsoCode(guest?.country, supplierType, condosCountriesCode) || '';

    let state = '';
    if (country === 'US') {
      const raw = (guest?.stateCode || '').toUpperCase();
      const states = getState(guest?.country, condosCountriesCode, supplierType) || [];
      const stateName = states.find((s) => (s.code || '').toUpperCase() === raw)?.name;
      const postal = stateName
        ? USA_STATES.find((s) => s.name.toLowerCase() === stateName.toLowerCase())?.postalCode
        : undefined;
      state = (postal || raw || '').toUpperCase();
    }

    return { country, state };
  };

  /** Last residency mirrored from the primary address, so the sync can tell an address edit from a
   *  state the guest picked by hand in the insurance box (allowed while the address is in the US —
   *  e.g. to retry a state whose quote failed). Without this the next update would revert them. */
  lastDerivedResidency: { country: string; state: string } | null = null;

  /** Keep the insurance residency (and its quote) in lock-step with the primary-address section while
   *  the condo full-Stripe insurance step is shown. Only acts when the *address* changed, so it won't
   *  loop on the quote's own store updates and won't overwrite a manual pick. */
  syncForceFullResidencyFromGuest = () => {
    if (!this.isForceFullDetailsInsuranceActive()) {
      return;
    }

    const derived = this.deriveResidencyFromGuest();
    const previous = this.lastDerivedResidency;
    const addressChanged =
      !!previous && (derived.country !== previous.country || derived.state !== previous.state);
    const differsFromSelection =
      derived.country !== this.state.insuranceResidencyCountry ||
      derived.state !== this.state.insuranceResidencyState;

    this.lastDerivedResidency = derived;

    if (!differsFromSelection || (previous && !addressChanged)) {
      return;
    }

    this.setState({
      insuranceResidencyCountry: derived.country,
      insuranceResidencyState: derived.state,
    });

    if (derived.country === 'US' && derived.state) {
      this.props.refreshInsuranceQuote(derived.state);
    } else {
      this.props.resetInsurance();
    }
  };

  checkFormValidity = debounce(() => {
    if (!this.formRef.current) return;

    const { loginStore, menuStore } = this.props;
    const { account } = loginStore;
    const stripeRegionOk = computeIsStripePaymentMethodsEnabled(
      account,
      menuStore?.items?.siteId,
      menuStore?.items?.organizationId,
    );
    const suppressStripePaymentUI = stripeRegionOk && !!account?.forceStripeFull;
    const paymentSectionRelevant =
      !suppressStripePaymentUI || this.state.forceFullStripeCheckoutPhase === 'payment';

    // When diverted to the legacy card form the billing country/state are locked to the page-1
    // insurance selection (disabled, pre-filled from the store). They must not gate the button —
    // their form values may lag the store value, so treat them as always satisfied here.
    const forceFullLegacyCard = this.isForceFullLegacyCardActive();
    const isLockedBillingKey = (key: string): boolean =>
      forceFullLegacyCard && (key === 'country' || key === 'state');

    const rawErrors = this.formRef.current.getFieldsError();
    const relevantErrors = paymentSectionRelevant
      ? rawErrors
      : rawErrors.filter(({ name }) => {
          const key = Array.isArray(name) ? name[0] : name;
          return typeof key === 'string' ? !CONDO_PAYMENT_ROOT_KEYS.has(key) : true;
        });

    const hasErrors = relevantErrors
      .filter(({ name }) => {
        if (!name.length) return false;
        const key = Array.isArray(name) ? name[0] : name;
        if (typeof key !== 'string') return true;
        return (
          key !== 'saveCard' &&
          key !== 'addressLine2' &&
          key !== 'primaryAddressLine2' &&
          !isLockedBillingKey(key)
        );
      })
      .some(({ errors }) => errors.length > 0);

    const getCondoBookingGuest = localStorage.getItem('CONDO_BOOKING_GUEST_INFO_LABEL');
    let condoBookingGuest: any = {};
    if (getCondoBookingGuest && !isEmpty(getCondoBookingGuest)) {
      condoBookingGuest = JSON.parse(getCondoBookingGuest);
    }
    if (!isEmpty(condoBookingGuest)) {
      this.formRef.current?.setFieldsValue({ email: condoBookingGuest?.email ?? undefined });
      this.formRef.current?.setFieldsValue({ additionalEmail: condoBookingGuest?.additionalEmail ?? undefined });
    }

    const allFields = this.formRef.current.getFieldsValue();

    const filteredFields = Object.keys(allFields)
      .filter((key) => {
        if (!paymentSectionRelevant && CONDO_PAYMENT_ROOT_KEYS.has(key)) return false;
        if (
          key === 'saveCard' ||
          key === 'addressLine2' ||
          key === 'primaryAddressLine2' ||
          key === 'additionalEmail' ||
          isLockedBillingKey(key)
        )
          return false;
        return key.length > 0;
      })
      .reduce((obj: Record<string, unknown>, key: string) => {
        obj[key] = allFields[key];
        return obj;
      }, {});

    const allFieldsTouched = Object.values(filteredFields).every((value) => {
      if (value !== undefined && value !== '') return true;
      if (
        value &&
        typeof value === 'object' &&
        value !== null &&
        'number' in (value as object)
      ) {
        const p = value as { number?: string; code?: string };
        return !!(p.number && p.code);
      }
      return false;
    });

    this.setState({ isButtonCompleteHidden: !hasErrors && allFieldsTouched });
  }, 500);


  render(): React.ReactNode {
    const { condoReviewBookStore, menuStore, loginStore, reviewBookStore, insuranceStore, intl } =
      this.props;
    const {
      isSomeoneElse,
      isAccept,
      isAcceptKnowBeforeYouGo,
      isAcceptNoChangesAllowed,
      isAcceptCancellationPolicy,
      showNotRefundableMessage,
    } = this.state;
    const {
      card,
      guest,
      condoBookingSummary,
      loadingBooking,
      bookingComplete,
      bookingErrorCode,
      isBookingPending,
      isAlternativeUnitsAvailable,
      selectedCondoReviewClientCash,
      stripeLoading,
      errorStripe,
      rewardId,
    } = condoReviewBookStore;
    const { threeDSLoading } = reviewBookStore;
    const { account, userWallet, userWalletData, userWalletReward } = loginStore;

    if (bookingComplete && (!condoBookingSummary || isEmpty(condoBookingSummary))) {
      return (
        <div className="condo-review-book-left-wrapper print" ref={this.wrapperRef}>
          <BookingConfirmed isBookingComplete={bookingComplete} />
          {isBookingPending && <CondoBookingPendingNotification />}
          {bookingErrorCode === BookingErrorsEnum.SoldOut && (
            <CondoUnitNotAvailableNotification
              isAlternativeUnitsAvailable={isAlternativeUnitsAvailable}
              searchCondos={this.searchCondo}
              bookAnotherUnit={this.bookAnotherUnit}
            />
          )}
          <ThreeDSModal isCondo={true} />
          {threeDSLoading ? (
            <div className="condo-review-book__loading-container">
              <Loading />
            </div>
          ) : null}
          <ModalConfirmation
            message="non.refundable.reservation.message"
            title="non.refundable.reservation"
            yesMessage="yes"
            noMessage="no"
            visible={this.state.showNotRefundableConfirmModal}
            onCancel={() => this.setState({ showNotRefundableConfirmModal: false })}
            onConfirm={() =>
              this.setState({ showNotRefundableConfirmModal: false }, this.onCompleteBooking)
            }
          />
          <GlobalLoading isVisible={stripeLoading} />
        </div>
      );
    }

    const isNotification =
      bookingComplete || isBookingPending || bookingErrorCode === BookingErrorsEnum.SoldOut;
    const { balance, bookingPrice } = condoBookingSummary?.bookingCard ?? {};
    const { maxWalletClientCash, payNowPrice, maxRewardWalletAmount } = bookingPrice ?? {};
    const { selection, insurance, loading: insuranceLoading, error: insuranceError } = insuranceStore;

    const chargeDescription = GetPreferenceValue(account as IAccount, MERCHANT_CHARGE_DESCRIPTION_FIELD_KEY);
    const walletIsExternal = account?.walletIsExternal;
    const walletSkipNonRefundable = account?.walletSkipNonRefundable;
    const walletNoDecimals = account?.walletNoDecimals;
    const walletNoPassEarnings = account?.walletNoPassEarnings;
    const hasClientCash = account?.hasClientCash;
    const effectiveClientCashPercentage = GetEffectiveClientCashPercentage(loginStore);
    const enableInsurance = account?.enableInsurance;
    const skipPaymentCheckout = isEnableCreditLine(account);

    const maxWalletClientCashInt = maxWalletClientCash;

    const isLogged = !!userWallet;
    const convertionRate = userWalletData?.convertionRate ? userWalletData?.convertionRate : 1;

    /** Points × rate = discount in booking currency (matches unit-info / completeBooking). */
    const selectedCondoReviewClientCashDiscount =
      (selectedCondoReviewClientCash ? selectedCondoReviewClientCash : 0) * convertionRate;
    const finalBalanceIntermediate =
      (payNowPrice ?? 0) - selectedCondoReviewClientCashDiscount;
    const finalBalance = roundMoney2(finalBalanceIntermediate);

    const certificateHint = mergeCondoCertificateRouteHint(
      this.props.history.location.state,
      this.props.condoFiltersStore,
    );
    const certificateApplied = isCertificateApplied(
      account as IAccount,
      certificateHint?.certificateId || this.props.condoFiltersStore.certificateId,
    );
    const finalBalanceDisplay = roundMoney2(certificateApplied ? (payNowPrice ?? 0) : finalBalanceIntermediate);

    const eligibleClientCash = (finalBalance > 0 ? finalBalance : 0) * effectiveClientCashPercentage / 100;
    const isRequired = !skipPaymentCheckout && (!hasClientCash || finalBalance > 0);
    const currency = getSelectedCurrency(account as IAccount);
    const balanceCalculated = (balance ?? 0) / convertionRate;

    const maxWalletClientCashCalculated = maxWalletClientCashInt ? walletNoDecimals ? Math.floor(maxWalletClientCashInt / convertionRate) : maxWalletClientCashInt / convertionRate : null;
    const userWalletDataBalanceCalculatedInt = (walletNoDecimals && userWalletData?.balance) ? Math.floor(userWalletData?.balance) : userWalletData?.balance;
    const userWalletDataBalanceCalculated = userWalletDataBalanceCalculatedInt ? userWalletDataBalanceCalculatedInt : 0;
    const maxWalletAmountIntermediated = walletNoPassEarnings ?
      maxWalletClientCashCalculated ?
        (maxWalletClientCashCalculated && userWalletDataBalanceCalculated > maxWalletClientCashCalculated) ?
          maxWalletClientCashCalculated :
          userWalletDataBalanceCalculated :
        0 :
      userWalletDataBalanceCalculated > balanceCalculated ?
        balanceCalculated :
        userWalletDataBalanceCalculated;

    const maxWalletAmount =
      maxWalletClientCashCalculated && maxWalletAmountIntermediated > maxWalletClientCashCalculated
        ? maxWalletClientCashCalculated
        : maxWalletAmountIntermediated;

    const clientCash = selectedCondoReviewClientCash ? GetWalletNumber(selectedCondoReviewClientCash, account as IAccount) : Number(0).toFixed(walletNoDecimals ? 0 : 2);

    const insuranceBalance =
      selection === InsuranceSelection.YES && !!insurance?.productDetails?.price
        ? insurance?.productDetails?.price
        : 0;
    const isInsuranceSelected =
      selection === InsuranceSelection.YES && !!insurance?.productDetails?.price;

    /** Same basis as unit-info totalPayDisplay: pay after points + insurance − reward */
    const rewardDeductionExpress =
      rewardId && maxRewardWalletAmount ? maxRewardWalletAmount : 0;
    const expressChargeTotal = Math.max(
      0,
      finalBalance + insuranceBalance - rewardDeductionExpress,
    );
    const finalAmount = dollarsToStripeCents(expressChargeTotal);

    const selectedCondoReviewClientCashFinal = selectedCondoReviewClientCash ? selectedCondoReviewClientCash : 0;

    const stripeRegionOk =
      !skipPaymentCheckout &&
      computeIsStripePaymentMethodsEnabled(
        account,
        menuStore?.items?.siteId,
        menuStore?.items?.organizationId,
      );
    const suppressStripePaymentUI = stripeRegionOk && !!account?.forceStripeFull;
    const showExpressCheckoutFlow =
      !suppressStripePaymentUI &&
      stripeRegionOk &&
      this.state.expressWalletProbeComplete &&
      this.state.hasExpressWalletMethods;
    const paymentEffective = showExpressCheckoutFlow ? this.state.paymentSelected : 'card';

    const isCardPayment =
      !suppressStripePaymentUI &&
      !skipPaymentCheckout &&
      !isEmpty(paymentEffective) &&
      paymentEffective === 'card';
    const isForceFullStripePaymentStep =
      suppressStripePaymentUI && this.state.forceFullStripeCheckoutPhase === 'payment';
    const isCardPaymentEffective = isCardPayment || isForceFullStripePaymentStep;
    const showInsuranceGuestSection =
      !card?.id && !suppressStripePaymentUI && isCardPaymentEffective;

    // Force-full Stripe accounts can still sell insurance, but only via the legacy card path.
    // When insurance is enabled we offer it on the details page; choosing YES diverts checkout to
    // the legacy credit-card form (country locked to USA, state locked to the page-1 selection).
    const forceFullInsuranceEnabled =
      suppressStripePaymentUI &&
      !!enableInsurance &&
      !menuStore?.items?.isRemoveInsurance &&
      !card?.id;
    const forceFullDetailsInsurance =
      forceFullInsuranceEnabled && this.state.forceFullStripeCheckoutPhase === 'details';
    const forceFullLegacyCard =
      forceFullInsuranceEnabled &&
      !!insurance &&
      isEmpty(insuranceError) &&
      selection === InsuranceSelection.YES;
    // The guest must complete the insurance step before "go to payments": pick a country (and state
    // for the US), let the quote resolve, and explicitly accept/decline an available offer. The
    // Insurance component reports this via onResidencyStepChange. Only enforced in the details phase.
    const forceFullInsuranceBlocksNext =
      forceFullDetailsInsurance && this.state.forceFullInsuranceStepBlocked;
    const forceFullLockedStateCode =
      insuranceStore.travelersRequest?.residency?.isoStateOrProvince || 'FL';

    const isInsuranceSelectionMissing = isInsuranceBookingSelectionMissing(
      showInsuranceGuestSection || forceFullDetailsInsurance,
      enableInsurance,
      insurance,
      insuranceLoading,
      insuranceError,
      menuStore?.items?.isRemoveInsurance,
      selection,
    );
    const showCompleteBookingButton = skipPaymentCheckout || isCardPayment;
    const isOtherPayment =
      showExpressCheckoutFlow &&
      !isEmpty(this.state.paymentSelected) &&
      this.state.paymentSelected !== 'card';

    const shouldMountStripeExpressElements =
      !suppressStripePaymentUI &&
      stripeRegionOk &&
      (!this.state.expressWalletProbeComplete || this.state.hasExpressWalletMethods);

    const scrollToPaymentSelectDisabled = () => this.setState({ scrollToPaymentSelect: false });
    const VALIDATE_STRIPE_BTNS =
      skipPaymentCheckout ||
      (!isEmpty(paymentEffective) &&
        // The Stripe payment step manages its own validation, so we let it through — EXCEPT the
        // legacy card path (insurance opt-in), which is a real credit-card form and must satisfy
        // the same field validation as the normal card flow before the button enables.
        ((isForceFullStripePaymentStep && !forceFullLegacyCard) ||
          !!this.state.isButtonCompleteHidden) &&
        !isInsuranceSelectionMissing);

    /** Block submission whenever the entered guest email is empty / malformed. Belt-and-suspenders
     *  on top of the form-level `isButtonCompleteHidden` flag so this also gates the force-full
     *  phase-2 Complete button and the skipPaymentCheckout (credit-line) path. */
    const guestEmail = this.props.condoReviewBookStore.guest?.email;
    const isGuestEmailValid = isValidEmail(guestEmail);

    /** "Please, fill in all required fields to proceed". `VALIDATE_STRIPE_BTNS` also folds in the
     *  insurance answer, which would make this generic line appear (and disappear) because of the
     *  insurance step. On the force-full details page insurance has its own message right below, so
     *  here the line reflects the booking form only. */
    const showRequiredFieldsMessage = forceFullDetailsInsurance
      ? !skipPaymentCheckout && (!this.state.isButtonCompleteHidden || !isGuestEmailValid)
      : !VALIDATE_STRIPE_BTNS;

    const isCardCompleteBookingDisabled =
      !VALIDATE_STRIPE_BTNS ||
      !isGuestEmailValid ||
      !isAccept ||
      !isAcceptKnowBeforeYouGo ||
      !isAcceptNoChangesAllowed ||
      (!isAcceptCancellationPolicy &&
        !isEmpty(condoBookingSummary?.cancellationPolicyText ?? '')) ||
      (isInsuranceSelected && !this.state.isAcceptIsInsurance) ||
      forceFullInsuranceBlocksNext ||
      loadingBooking ||
      (hasClientCash && isLogged && !this.state.isClientCash) ||
      (account?.enableWalletReward && isLogged && !this.state.isReward) ||
      (hasClientCash &&
        isLogged &&
        !this.state.isClientCashNotRefundable &&
        (selectedCondoReviewClientCash ?? 0) > 0 &&
        !walletIsExternal &&
        !walletSkipNonRefundable) ||
      (hasClientCash &&
        isLogged &&
        (selectedCondoReviewClientCash ?? 0) > maxWalletAmount) ||
      (hasClientCash &&
        isLogged &&
        !!selectedCondoReviewClientCash &&
        selectedCondoReviewClientCash <= maxWalletAmount &&
        walletNoDecimals &&
        Math.floor(selectedCondoReviewClientCash) !== selectedCondoReviewClientCash);

    const validateForm = () => {
      // Force-full insurance step incomplete (no country/state picked, quote loading, or offer not
      // yet accepted/declined): flag the residency selectors in red and scroll to them.
      if (forceFullInsuranceBlocksNext) {
        this.setState({ showInsuranceResidencyErrors: true });
        this.insuranceContainerRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
        return;
      }
      const formRef = this.formRef.current?.validateFields();
      let promises = [formRef];
      const shouldIncludePayment = isCardPayment && !skipPaymentCheckout;

      if (showExpressCheckoutFlow && !skipPaymentCheckout && isEmpty(this.state.paymentSelected)) {
        this.setState({ scrollToPaymentSelect: true })
        const paymentSection = document.getElementById("payment-methods-select__card");
        if (paymentSection) {
          paymentSection.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      } else {
        scrollToPaymentSelectDisabled();
      }

      Promise.all(promises)
        .catch((error: IFormErrors) => {
          const { errorFields } = error;
          const { name } = errorFields[ZERO];
          const { scrollToField } = this.formRef.current ?? {};

          (() => {
            scrollToField?.(name[ZERO], { behavior: ScrollBehaviorEnum.Smooth });
          })();

          if (shouldIncludePayment && this.formRef.current) {
            const { scrollToField: scrollToPaymentField } = this.formRef.current;
            scrollToPaymentField(name[ZERO], { behavior: ScrollBehaviorEnum.Smooth });
          }
        });
    };

    const setPaymentSelected = (payment: string) => {
      const isLeavingCard =
        this.state.paymentSelected === 'card' && !isEmpty(payment) && payment !== 'card';
      const insuranceOffered =
        showInsuranceGuestSection &&
        !!enableInsurance &&
        !!insurance &&
        !menuStore?.items?.isRemoveInsurance;
      // Insurance only rides along with card payments. Warn before dropping it.
      if (isLeavingCard && insuranceOffered) {
        this.setState({ pendingPaymentSwitch: payment });
        return;
      }
      this.setState((prevState: IState) => ({
        ...prevState,
        paymentSelected: payment,
      }));
    };

    const setMultiplePayments = (payments: any) => {
      this.setState((prevState: IState) => ({
        ...prevState,
        multiplePayments: {
          ...payments,
        },
      }));
    };

    return (
      guest && (
        <div className="condo-review-book-left-wrapper print" ref={this.wrapperRef}>
          {bookingErrorCode || !isEmpty(errorStripe) ? this.getBookingErrorWarning(certificateApplied) : null}

          <div
            className={`condo-review-book ${isNotification ? 'hide-block' : ''}${
              suppressStripePaymentUI ? ' force-stripe-full-active' : ''
            }`}
          >
            <Form
              name="condo-review-book-rule"
              ref={this.formRef}
              onFieldsChange={this.checkFormValidity}
              autoComplete="off"
            >
              {/* Keep guest + email mounted across the force-full details/payment phase switch
                  (hidden via CSS on the payment step) instead of unmounting them. Remounting
                  re-runs CondoGuestInfo.componentDidMount, which reformats the phone and re-seeds
                  fields — wiping already-entered values and leaving the "Go to payments" button
                  stuck disabled when the guest returns from the payment step. */}
              <div
                style={
                  !suppressStripePaymentUI ||
                  this.state.forceFullStripeCheckoutPhase === 'details'
                    ? undefined
                    : { display: 'none' }
                }
              >
                <CondoGuestInfo
                  formRef={this.formRef as React.RefObject<FormInstance>}
                  onChangeSomeoneElse={this.onChangeSomeoneElse}
                  isSomeoneElse={isSomeoneElse}
                  onUpdateAddress={this.handleUpdateAddress}
                  onChangeCountryState={() => this.setState({ isAcceptIsInsurance: false })}
                  checkFormValidity={this.checkFormValidity}
                  isCardPayment={isCardPayment}
                />

                <CondoConfirmationEmail formRef={this.formRef as React.RefObject<FormInstance>} isSomeoneElse={isSomeoneElse} checkFormValidity={this.checkFormValidity}/>
              </div>

              <CondoPaymentMethod
                formRef={this.formRef as React.RefObject<FormInstance>}
                display={
                  (finalBalanceDisplay > 0 && !suppressStripePaymentUI && !skipPaymentCheckout) ||
                  (forceFullLegacyCard && isForceFullStripePaymentStep && finalBalance > 0)
                }
                isRequired={isRequired}
                setPaymentSelected={setPaymentSelected}
                paymentSelected={paymentEffective}
                multiplePayments={this.state.multiplePayments}
                scrollToPaymentSelect={this.state.scrollToPaymentSelect}
                scrollToPaymentSelectDisabled={scrollToPaymentSelectDisabled}
                checkFormValidity={this.checkFormValidity}
                showExpressCheckoutFlow={showExpressCheckoutFlow}
                lockUsBillingRegion={forceFullLegacyCard}
                lockedStateCode={forceFullLockedStateCode}
                hidePaymentTitle={suppressStripePaymentUI}
                hideSavedCards={suppressStripePaymentUI}
              />

              {!skipPaymentCheckout && !card?.id && isCardPayment ? (
                <div className="condo-review-book__wrapper" ref={this.insuranceContainerRef}>
                  <Insurance onChange={() => this.setState({ isAcceptIsInsurance: false })} />
                </div>) : null}

              {forceFullDetailsInsurance ? (
                <div className="condo-review-book__wrapper" ref={this.insuranceContainerRef}>
                  <Insurance
                    showResidencyCountryState
                    /* The state mirrors the primary address, but a US guest can override it here —
                       otherwise a state whose quote fails would leave them with no way to retry. */
                    disableResidencySelectors={this.state.insuranceResidencyCountry !== 'US'}
                    residencyCountry={this.state.insuranceResidencyCountry}
                    residencyState={this.state.insuranceResidencyState}
                    onResidencyCountryChange={(value) =>
                      this.setState({ insuranceResidencyCountry: value })
                    }
                    onResidencyStateChange={(value) =>
                      this.setState({ insuranceResidencyState: value })
                    }
                    highlightErrors={this.state.showInsuranceResidencyErrors}
                    onResidencyStepChange={(blocked) => {
                      if (this.state.forceFullInsuranceStepBlocked !== blocked) {
                        this.setState({ forceFullInsuranceStepBlocked: blocked });
                      }
                    }}
                    onChange={() => this.setState({ isAcceptIsInsurance: false })}
                  />
                </div>) : null}
            </Form>

            {(!suppressStripePaymentUI ||
              this.state.forceFullStripeCheckoutPhase === 'details') && (
            <>
            <CondoCancellationPolicies
              certificateApplied={certificateApplied}
              displayCheckbox={!bookingComplete}
              disable={loadingBooking}
              checked={this.state.isAcceptCancellationPolicy}
              onChangeAcceptPolicy={this.onChangeAcceptCancellationPolicy}
              condoBookingSummary={condoBookingSummary as ICondoBookingSummary}
            />

            <div className="condo-review-book__wrapper">
              <Checkbox checked={this.state.isAccept} onChange={this.onChangeAccept} disabled={loadingBooking} />
              <p className="condo-review-book__accept-text">
                <FormattedMessage
                  id="accept.you.will.be.charged"
                  values={{
                    price: renderNumber(finalBalanceDisplay + insuranceBalance, 2),
                    type: <FormattedMessage id="Condo" />,
                    reservation_name: (!isEmpty(chargeDescription) && condoBookingSummary?.customProvider) ? chargeDescription : <FormattedMessage id="accept.you.will.be.charged.travcoding" />,
                    currency
                  }}
                />
              </p>
            </div>

            <div className="review-book__wrapper">
              <Checkbox checked={this.state.isAcceptKnowBeforeYouGo} onChange={this.onChangeAcceptKnowBeforeYouGo} disabled={loadingBooking} />
              <p className="review-book__accept-text">
                <FormattedMessage id="accetp.no.changes.allow" />
              </p>
            </div>

            <div className="review-book__wrapper">
              <Checkbox checked={this.state.isAcceptNoChangesAllowed} onChange={this.onChangeAcceptNoChangesAllowed} disabled={loadingBooking} />
              <p className="review-book__accept-text">
                <FormattedMessage id="by.checking.this.box.you.acknowledge.that.you.have.read.know.before.you.go" />
              </p>
            </div>

            {hasClientCash && isLogged && (
              <div className="review-book__wrapper">
                <Checkbox checked={this.state.isClientCash} onChange={this.onChangeAcceptClientCash} disabled={loadingBooking} />
                <p className="review-book__accept-text">
                  {!walletIsExternal ? (
                    <FormattedMessage
                      id={
                        effectiveClientCashPercentage > 0
                          ? 'wallet.client.cash.by.checking.acknowledge'
                          : 'wallet.client.cash.by.checking.acknowledge.no_earnings'
                      }
                      values={{
                        clientCash,
                        reward: walletNoDecimals
                          ? Math.floor(eligibleClientCash).toFixed(0)
                          : eligibleClientCash.toFixed(2),
                        clientCashPercentage: effectiveClientCashPercentage,
                        clientCashName: account?.walletClientCashName,
                      }}
                    />
                  ) : (
                    <FormattedMessage
                      id="wallet.client.cash.by.checking.acknowledge.external"
                      values={{ clientCash, clientCashName: account?.walletClientCashName }}
                    />
                  )}
                </p>
              </div>
            )}

            {!walletSkipNonRefundable && !walletIsExternal && hasClientCash && isLogged && selectedCondoReviewClientCashFinal > 0 && (
              <div className="review-book__wrapper">
                <Checkbox checked={this.state.isClientCashNotRefundable} onChange={this.onChangeAcceptClientCashNotRefundable} disabled={loadingBooking} />
                <p className="review-book__accept-text">
                  <FormattedMessage id="wallet.client.not_refundable.acknowledge" values={{ clientCash, currency, clientCashName: account?.walletClientCashName }} />
                </p>

                <ModalMessage
                  text={intl.formatMessage(
                    { id: 'wallet.client.not_refundable.modal.acknowledge' },
                    { clientCashName: account?.walletClientCashName },
                  )}
                  disableTextLocalization
                  disableTitleLocalization={true}
                  visible={showNotRefundableMessage}
                  onCancel={() => this.setState({ showNotRefundableMessage: false })}
                />
              </div>
            )}

            {account?.enableWalletReward && isLogged && (
              <div className="review-book__wrapper">
                <Checkbox checked={this.state.isReward} onChange={this.onChangeAcceptReward} disabled={loadingBooking} />
                <p className="review-book__accept-text">
                  {rewardId ? (
                    <FormattedMessage
                      id="wallet.reward.by.checking.acknowledge"
                      values={{
                        rewardFormatted: `${getCurrencyText(currency)}${renderNumber((userWalletReward?.allRewards ?? []).find((r) => r.rewardId === rewardId)?.rewardValue ?? 0, 2)}`,
                        maxRewardFormatted: `${getCurrencyText(currency)}${renderNumber(maxRewardWalletAmount ?? 0, 2)}`,
                      }}
                    />
                  ) : (
                    <FormattedMessage id="wallet.reward.by.checking.acknowledge.not_using" />
                  )}
                </p>
              </div>
            )}

            {isInsuranceSelected ? (
              <div className="review-book__wrapper">
                <Checkbox checked={this.state.isAcceptIsInsurance} onChange={this.onChangeAcceptIsInsurance} disabled={loadingBooking} />
                <p className="review-book__accept-text">
                  <FormattedMessage id="insurance.policy.disclaimer" />
                </p>
              </div>
            ) : null}

            {hasClientCash && !isLogged && effectiveClientCashPercentage > 0 && (
              <div className="review-book__wrapper client-cash-message">
                <p className="review-book__accept-text">
                  <FontAwesomeIcon icon={faTriangleExclamation} />{' '}
                  <FormattedMessage
                    id="wallet.client.not_logged.acknowledge"
                    values={{
                      reward: eligibleClientCash.toFixed(2),
                      currency,
                      clientCashPercentage: effectiveClientCashPercentage,
                      clientCashName: account?.walletClientCashName,
                    }}
                  />
                </p>
                <p
                  className="booking-confirmed__contact-property"
                  style={{ fontSize: '18px', marginTop: '10px', textAlign: 'right' }}
                >
                  <BlueButton onClick={this.hangleGoToLogin}>
                    <FormattedMessage id="sign.in" />
                  </BlueButton>{' '}
                  <FormattedMessage id="or" />{' '}
                  <BlueButton onClick={this.hangleGoToSignUp}>
                    <FormattedMessage id="sign.up" />
                  </BlueButton>
                </p>
              </div>
            )}
            </>
            )}

            {(!suppressStripePaymentUI ||
              this.state.forceFullStripeCheckoutPhase === 'details') && (
            <div
              className={`condo-review-book__wrapper ${isOtherPayment || suppressStripePaymentUI
                ? 'others-methods'
                : 'booking-complete'
                }`}
            >
              <p className="condo-review-book__agree-navigation-text">
                <FormattedMessage
                  id="agree.booking"
                  values={{
                    pp: (msg: React.ReactNode[]) => (
                      <a target="_blank" rel="noreferrer" href="https://www.travcoding.com/privacy-policy/" onClick={() => {
                        ReactGA.event({
                          category: account?.name as string,
                          action: `${C_PP}_${account?.name.toUpperCase()}`,
                          label: `User clicked privacy policy on book`,
                          nonInteraction: false,
                        });
                      }}>
                        {msg}
                      </a>
                    ),
                    tu: (msg: React.ReactNode[]) => (
                      <a target="_blank" rel="noreferrer" href="https://www.travcoding.com/terms-of-use/" onClick={() => {
                        ReactGA.event({
                          category: account?.name as string,
                          action: `${C_TERMS}_${account?.name.toUpperCase()}`,
                          label: `User clicked terms of use on book`,
                          nonInteraction: false,
                        });
                      }}>
                        {msg}
                      </a>
                    ),
                  }}
                />
                {menuStore.items?.baseUrl ? (
                  <a
                    className="condo-review-book__agree-navigation-link"
                    href={getFullUrl(menuStore.items?.baseUrl, PRIVACY)}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FormattedMessage id="privacy.policy" />
                  </a>
                ) : null}
              </p>
            </div>
            )}

            <div
              className={`condo-review-book__wrapper ${isOtherPayment || suppressStripePaymentUI
                ? 'others-methods'
                : 'booking-complete'
                }${suppressStripePaymentUI ? ' stripe-checkout-force-full-active' : ''}`}
            >
              <div
                className={[
                  'condo-review-book__complete-btn',
                  isOtherPayment && 'stripe-btn',
                  (isOtherPayment || suppressStripePaymentUI) && 'others-methods',
                  suppressStripePaymentUI && 'force-stripe-full-checkout',
                ]
                  .filter(Boolean)
                  .join(' ')}
              >
                <>
                  {suppressStripePaymentUI &&
                    this.state.forceFullStripeCheckoutPhase === 'details' && (
                    <div className="stripe-force-full-next">
                      <BlueButton
                        onClick={this.handleForceFullGoToPayment}
                        disabled={isCardCompleteBookingDisabled}
                      >
                        <FormattedMessage id="review.book.checkout.next" />
                      </BlueButton>
                    </div>
                  )}
                  {suppressStripePaymentUI && isForceFullStripePaymentStep && !forceFullLegacyCard && (
                    <ForceFullStripeCheckout
                      type={StripeBtnTypes.Condo}
                      amount={finalAmount}
                      currency={account?.currency}
                      totalPrice={finalAmount}
                      isDisabled={isCardCompleteBookingDisabled}
                      scrollToError={this.scrollToError}
                      forceFullStripeBack={{
                        onClick: this.handleForceFullBackToDetails,
                        disabled: loadingBooking || stripeLoading,
                      }}
                    />
                  )}
                  {suppressStripePaymentUI && isForceFullStripePaymentStep && forceFullLegacyCard && (
                    <div className="force-full-legacy-card">
                      <div className="force-full-stripe-checkout__action force-full-stripe-checkout__action--card">
                        <WhiteButton
                          htmlType="button"
                          className="force-full-stripe-checkout__back"
                          onClick={this.handleForceFullBackToDetails}
                          disabled={loadingBooking}
                        >
                          <FormattedMessage id="review.book.checkout.back" />
                        </WhiteButton>
                        <BlueButton
                          className="force-full-stripe-checkout__complete"
                          onClick={this.handleOnCompleteBooking}
                          disabled={isCardCompleteBookingDisabled}
                        >
                          <FormattedMessage id="complete.booking" />
                          {loadingBooking && <Spin />}
                        </BlueButton>
                      </div>
                    </div>
                  )}

                  {!suppressStripePaymentUI && shouldMountStripeExpressElements && (
                    <div
                      style={
                        !this.state.expressWalletProbeComplete
                          ? STRIPE_EXPRESS_PROBE_SR_ONLY
                          : { display: isOtherPayment ? '' : 'none' }
                      }
                    >
                      <Elements
                        stripe={stripePromise}
                        options={{
                          mode: 'payment',
                          // Must match the BFF PaymentIntent (manual capture). Capture happens after the
                          // provider booking succeeds; on failure the authorization is voided (no refund).
                          captureMethod: 'manual',
                          amount: finalAmount,
                          currency: (account?.currency ?? 'usd').toLowerCase(),
                          appearance: {
                            /*...*/
                          },
                          // paymentMethodTypes: ['card', 'link', 'amazon_pay'],
                          // payment_method_types: ['card', 'link', 'amazon_pay'],
                        }}
                      >
                        <ExpressCheckoutButtons
                          totalPrice={finalAmount}
                          formsRef={null}
                          onExpressWalletAvailabilityResolved={this.onExpressWalletAvailabilityResolved}
                          isDisabled={isCardCompleteBookingDisabled}
                          type={StripeBtnTypes.Condo}
                          scrollToError={this.scrollToError}
                          setMultiplePayments={setMultiplePayments}
                          paymentSelected={this.state.paymentSelected}
                        />
                      </Elements>
                    </div>)}

                  {!suppressStripePaymentUI && showCompleteBookingButton && (
                    <BlueButton
                      onClick={this.handleOnCompleteBooking}
                      disabled={isCardCompleteBookingDisabled}
                    >
                      <FormattedMessage id="complete.booking" />
                      {loadingBooking && <Spin />}
                    </BlueButton>)}
                </>

              </div>
            </div>

            {showRequiredFieldsMessage
              && <p style={{ fontWeight: 'bold' }} className='payment-complete-fields'>Please, fill in all required fields to proceed {' '}
                <u onClick={validateForm} style={{ cursor: 'pointer' }}>(View Fields)</u></p>}

            {(showInsuranceGuestSection || forceFullDetailsInsurance) && (
              <InsuranceRequiredMessage
                display={
                  ((isInsuranceSelectionMissing || forceFullInsuranceBlocksNext) &&
                    (!suppressStripePaymentUI ||
                      this.state.forceFullStripeCheckoutPhase === 'details')) as boolean
                }
                insuranceContainerRef={this.insuranceContainerRef as React.RefObject<HTMLDivElement>}
                classNameContainer="condo-review-book__wrapper"
              />)}

          </div>

          <BookingConfirmed isBookingComplete={bookingComplete} />

          {isBookingPending && <CondoBookingPendingNotification />}

          {bookingErrorCode === BookingErrorsEnum.SoldOut && (
            <CondoUnitNotAvailableNotification
              isAlternativeUnitsAvailable={isAlternativeUnitsAvailable}
              searchCondos={this.searchCondo}
              bookAnotherUnit={this.bookAnotherUnit}
            />
          )}

          <ThreeDSModal isCondo={true} />

          {threeDSLoading ? (
            <div className="condo-review-book__loading-container">
              <Loading />
            </div>) : null}

          <ModalConfirmation
            message="non.refundable.reservation.message"
            title="non.refundable.reservation"
            yesMessage="yes"
            noMessage="no"
            visible={this.state.showNotRefundableConfirmModal}
            onCancel={() => this.setState({ showNotRefundableConfirmModal: false })}
            onConfirm={() =>
              this.setState({ showNotRefundableConfirmModal: false }, this.onCompleteBooking)
            }
          />

          <ModalConfirmation
            message="insurance.payment.switch.message"
            title="insurance.payment.switch.title"
            yesMessage="insurance.payment.switch.continue"
            noMessage="insurance.payment.switch.keep"
            visible={!!this.state.pendingPaymentSwitch}
            onCancel={() => this.setState({ pendingPaymentSwitch: null })}
            onConfirm={() => {
              const nextPayment = this.state.pendingPaymentSwitch as string;
              this.props.setInsuranceSelection(InsuranceSelection.NO);
              this.setState({
                pendingPaymentSwitch: null,
                paymentSelected: nextPayment,
                isAcceptIsInsurance: false,
              });
            }}
          />
          <GlobalLoading isVisible={stripeLoading} />
        </div>
      )
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    reviewBookStore: state.reviewBookStore,
    condoReviewBookStore: state.condoReviewBookStore,
    menuStore: state.navigationMenuStore,
    redeemCodeStore: state.redeemCodeStore,
    condoFiltersStore: state.condoFiltersStore,
    loginStore: state.loginStore,
    insuranceStore: state.insuranceStore,
    condosStaticStore: state.condosStaticStore,
    certificatesStore: state.certificatesStore,
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  setCondoGuest,
  getCondoBookPackageWithCard,
  setCondoPriceChangedError,
  setCondoBookingComplete,
  setErrorMessageExpirationDate,
  setErrorMessageCardNumber,
  setErrorMessageZipCode,
  getNavigationMenu,
  setLoginRedirect,
  setInsuranceSelection: insuranceActions.setSelection,
  refreshInsuranceQuote,
  resetInsurance: insuranceActions.reset,
};

export const CondoReviewBookComponentIntl = injectIntl(CondoReviewBookComponent);

export const CondoReviewBook = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(CondoReviewBookComponentIntl));
